// Weekly workout split recommendations. Body part per day + suggested exercises.
// templateKey maps to backend PROGRAM_TEMPLATES for "apply to calendar".
export const SPLIT_DAY_KEYS = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
export const SPLIT_DAY_LABELS = {
  id: { mon: "Senin", tue: "Selasa", wed: "Rabu", thu: "Kamis", fri: "Jumat", sat: "Sabtu", sun: "Minggu" },
  en: { mon: "Mon", tue: "Tue", wed: "Wed", thu: "Thu", fri: "Fri", sat: "Sat", sun: "Sun" },
};

const D = (id, en, exercises, type = "workout") => ({ id, en, exercises, type });
const REST = D("Istirahat", "Rest", [], "rest");
const BODYCOMP = D("Timbang & Ukur", "Weigh & Measure", [], "bodycomp");

export const WORKOUT_SPLITS = {
  brosplit: {
    templateKey: "brosplit",
    label: { id: "Bro Split (per otot)", en: "Bro Split (per muscle)" },
    desc: { id: "Fokus 1 grup otot per hari — cocok untuk hipertrofi.", en: "One muscle group per day — great for hypertrophy." },
    days: {
      mon: D("Dada", "Chest", ["Barbell Bench Press", "Incline Dumbbell Press", "Chest Fly", "Cable Crossover", "Push-up"]),
      tue: D("Bahu", "Shoulders", ["Overhead Press", "Lateral Raise", "Front Raise", "Reverse Pec Deck", "Arnold Press"]),
      wed: D("Punggung", "Back", ["Lat Pulldown", "Bent-over Barbell Row", "Seated Cable Row", "Pull-up", "Face Pull"]),
      thu: D("Kaki", "Legs", ["Barbell Back Squat", "Leg Press", "Romanian Deadlift", "Leg Extension", "Standing Calf Raise"]),
      fri: D("Lengan", "Arms", ["Barbell Curl", "Triceps Pushdown", "Hammer Curl", "Overhead Triceps Extension", "Preacher Curl"]),
      sat: BODYCOMP,
      sun: REST,
    },
  },
  beginner: {
    templateKey: "beginner",
    label: { id: "Pemula (4 hari)", en: "Beginner (4 days)" },
    desc: { id: "Pola sederhana dada/punggung/kaki/bahu untuk pemula.", en: "Simple chest/back/legs/shoulders split for beginners." },
    days: {
      mon: D("Dada & Trisep", "Chest & Triceps", ["Barbell Bench Press", "Incline Dumbbell Press", "Chest Fly", "Triceps Pushdown", "Push-up"]),
      tue: D("Punggung & Bisep", "Back & Biceps", ["Lat Pulldown", "Seated Cable Row", "One-arm Dumbbell Row", "Dumbbell Curl", "Face Pull"]),
      wed: REST,
      thu: D("Kaki", "Legs", ["Barbell Back Squat", "Leg Press", "Romanian Deadlift", "Leg Extension", "Standing Calf Raise"]),
      fri: D("Bahu & Core", "Shoulders & Core", ["Overhead Press", "Lateral Raise", "Reverse Pec Deck", "Plank", "Hanging Leg Raise"]),
      sat: BODYCOMP,
      sun: REST,
    },
  },
  upperlower: {
    templateKey: "upperlower",
    label: { id: "Upper / Lower", en: "Upper / Lower" },
    desc: { id: "Badan atas & bawah bergantian, 4 hari.", en: "Alternating upper & lower body, 4 days." },
    days: {
      mon: D("Upper A", "Upper A", ["Barbell Bench Press", "Bent-over Barbell Row", "Overhead Press", "Lat Pulldown", "Dumbbell Curl"]),
      tue: D("Lower A", "Lower A", ["Barbell Back Squat", "Romanian Deadlift", "Leg Press", "Standing Calf Raise", "Plank"]),
      wed: REST,
      thu: D("Upper B", "Upper B", ["Incline Dumbbell Press", "Seated Cable Row", "Lateral Raise", "Chin-up", "Triceps Pushdown"]),
      fri: D("Lower B", "Lower B", ["Hack Squat", "Lying Leg Curl", "Walking Lunge", "Standing Calf Raise", "Hanging Leg Raise"]),
      sat: BODYCOMP,
      sun: REST,
    },
  },
  fullbody3: {
    templateKey: "fullbody3",
    label: { id: "Full Body (3 hari)", en: "Full Body (3 days)" },
    desc: { id: "Latih seluruh tubuh 3x seminggu — hemat waktu.", en: "Train whole body 3x a week — time efficient." },
    days: {
      mon: D("Full Body A", "Full Body A", ["Barbell Back Squat", "Barbell Bench Press", "Bent-over Barbell Row", "Overhead Press", "Plank"]),
      tue: REST,
      wed: D("Full Body B", "Full Body B", ["Romanian Deadlift", "Incline Dumbbell Press", "Lat Pulldown", "Lateral Raise", "Hanging Leg Raise"]),
      thu: REST,
      fri: D("Full Body C", "Full Body C", ["Leg Press", "Push-up", "Seated Cable Row", "Dumbbell Curl", "Triceps Pushdown"]),
      sat: BODYCOMP,
      sun: REST,
    },
  },
  fatloss: {
    templateKey: "fatloss",
    label: { id: "Bakar Lemak", en: "Fat Loss" },
    desc: { id: "Kekuatan full body + kardio & HIIT, repetisi lebih tinggi — untuk turunkan lemak.", en: "Full-body strength + cardio & HIIT, higher reps — for fat loss." },
    days: {
      mon: D("Full Body + Kardio A", "Full Body + Cardio A", ["Goblet Squat", "Push-up", "Lat Pulldown", "Kettlebell Swing", "Cycling"]),
      tue: D("HIIT & Inti", "HIIT & Core", ["Burpee", "Mountain Climbers", "Bicycle Crunch", "Plank", "Rowing Machine"]),
      wed: REST,
      thu: D("Full Body + Kardio B", "Full Body + Cardio B", ["Leg Press", "Incline Dumbbell Press", "Seated Cable Row", "Lateral Raise", "Elliptical"]),
      fri: D("Kardio & Inti", "Cardio & Core", ["Treadmill Run", "Kettlebell Swing", "Russian Twist", "Hanging Leg Raise", "Stair Climber"]),
      sat: BODYCOMP,
      sun: REST,
    },
  },
  lowimpact: {
    templateKey: "lowimpact",
    label: { id: "Ramah Sendi", en: "Low Impact" },
    desc: { id: "Mesin & berat badan + kardio rendah, ramah sendi — awal aman untuk berat berlebih.", en: "Machine & bodyweight + low-impact cardio, joint-friendly — a safe start." },
    days: {
      mon: D("Full Body Ringan A", "Easy Full Body A", ["Leg Press", "Chest Press Machine", "Lat Pulldown", "Seated Cable Row", "Cycling"]),
      tue: REST,
      wed: D("Kardio Rendah & Inti", "Low Cardio & Core", ["Elliptical", "Rowing Machine", "Glute Bridge", "Dead Bug", "Plank"]),
      thu: REST,
      fri: D("Full Body Ringan B", "Easy Full Body B", ["Goblet Squat", "Leg Extension", "Lying Leg Curl", "Cable Lateral Raise", "Stair Climber"]),
      sat: BODYCOMP,
      sun: REST,
    },
  },
};

export const SPLIT_KEYS = ["fatloss", "lowimpact", "fullbody3", "beginner", "upperlower", "brosplit"];

// Map BMI category -> recommended split key.
export const bmiToSplit = (category) => ({
  underweight: "fullbody3",
  normal: "upperlower",
  overweight: "fatloss",
  obese: "lowimpact",
}[category] || "beginner");

// Suggested sets × reps per exercise. Compound → heavier/lower reps, isolation → higher reps, core → highest.
const SETREP = {
  // Compound (4 × 6-10)
  "Barbell Bench Press": { sets: 4, reps: "6-10" },
  "Barbell Back Squat": { sets: 4, reps: "6-10" },
  "Romanian Deadlift": { sets: 4, reps: "6-10" },
  "Overhead Press": { sets: 4, reps: "6-10" },
  "Bent-over Barbell Row": { sets: 4, reps: "6-10" },
  "Leg Press": { sets: 4, reps: "8-12" },
  "Hack Squat": { sets: 4, reps: "8-12" },
  "Pull-up": { sets: 4, reps: "6-10" },
  "Chin-up": { sets: 4, reps: "6-10" },
  "Lat Pulldown": { sets: 4, reps: "8-12" },
  "Seated Cable Row": { sets: 4, reps: "8-12" },
  "Incline Dumbbell Press": { sets: 4, reps: "8-12" },
  "Arnold Press": { sets: 3, reps: "8-12" },
  "Walking Lunge": { sets: 3, reps: "10-12" },
  "One-arm Dumbbell Row": { sets: 3, reps: "8-12" },
  // Isolation (3 × 10-15)
  "Chest Fly": { sets: 3, reps: "10-15" },
  "Cable Crossover": { sets: 3, reps: "12-15" },
  "Push-up": { sets: 3, reps: "12-20" },
  "Lateral Raise": { sets: 3, reps: "12-15" },
  "Front Raise": { sets: 3, reps: "12-15" },
  "Reverse Pec Deck": { sets: 3, reps: "12-15" },
  "Face Pull": { sets: 3, reps: "12-15" },
  "Leg Extension": { sets: 3, reps: "12-15" },
  "Lying Leg Curl": { sets: 3, reps: "10-15" },
  "Standing Calf Raise": { sets: 4, reps: "12-20" },
  "Barbell Curl": { sets: 3, reps: "8-12" },
  "Dumbbell Curl": { sets: 3, reps: "10-12" },
  "Hammer Curl": { sets: 3, reps: "10-12" },
  "Preacher Curl": { sets: 3, reps: "10-12" },
  "Triceps Pushdown": { sets: 3, reps: "10-15" },
  "Overhead Triceps Extension": { sets: 3, reps: "10-12" },
  // Core (3 × 12-20 / hold)
  "Plank": { sets: 3, reps: "30-60s" },
  "Hanging Leg Raise": { sets: 3, reps: "12-20" },
  "Bicycle Crunch": { sets: 3, reps: "15-20" },
  "Russian Twist": { sets: 3, reps: "20-30" },
  "Dead Bug": { sets: 3, reps: "10-12" },
  "Glute Bridge": { sets: 3, reps: "12-20" },
  // Cardio (1 × durasi)
  "Cycling": { sets: 1, reps: "15-20 min" },
  "Elliptical": { sets: 1, reps: "15-20 min" },
  "Rowing Machine": { sets: 1, reps: "10-15 min" },
  "Treadmill Run": { sets: 1, reps: "15-20 min" },
  "Stair Climber": { sets: 1, reps: "10-15 min" },
  // HIIT (interval)
  "Burpee": { sets: 4, reps: "12-15" },
  "Mountain Climbers": { sets: 4, reps: "30-45s" },
  "Kettlebell Swing": { sets: 4, reps: "15-20" },
};

const DEFAULT_SETREP = { sets: 3, reps: "10-12" };

export const getSetRep = (name) => SETREP[name] || DEFAULT_SETREP;
export const formatSetRep = (name) => {
  const s = getSetRep(name);
  return `${s.sets} × ${s.reps}`;
};
